import React, { useEffect, useState } from 'react';
import {
	ChecklistItem,
	ProfileSection,
	ProfileSectionTitle,
} from '../Global/profileStyles';
import { IonLabel, IonToggle, ToggleChangeEventDetail } from '@ionic/react';
import { useAppDispatch, useAppSelector } from '../../state/hooks';
import { shallowEqual } from 'react-redux';
import { RootState } from '../../state/store';
import { ITaxonomy } from '../../models/interfaces/ITaxonomy';
import { IonToggleCustomEvent } from '@ionic/core';
import { UPDATE_PREFS_TOPICS } from '../../state/prefsSlice';
import _ from 'lodash';

type TopicsListProps = {
	topics: ITaxonomy[];
};

type TaxToggleProps = {
	topic: ITaxonomy;
	clickCallback: (
		e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>,
		topic: ITaxonomy,
	) => {};
};

const TopicToggle = ({ topic, clickCallback }: TaxToggleProps) => {
	const topicPrefs = useAppSelector(
		(state: RootState) => state.prefs.topics,
		shallowEqual,
	);
	const isChecked = !!_.find(topicPrefs, { slug: topic.slug });
	return (
		<>
			<IonLabel>{_.unescape(topic.title)}</IonLabel>
			<IonToggle
				onIonChange={(e) => clickCallback(e, topic)}
				checked={isChecked}
			/>
		</>
	);
};

const TopicsList: React.FC<TopicsListProps> = ({ topics }) => {
	const dispatch = useAppDispatch();
	const topicPrefs = useAppSelector(
		(state: RootState) => state.prefs.topics,
		shallowEqual,
	);
	const sortedTopics = [...topics].sort((a, b) =>
		_.unescape(a.title).localeCompare(_.unescape(b.title)),
	);

	const clickHandler = (
		e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>,
		topic: ITaxonomy,
	) => {
		e.stopImmediatePropagation();
		console.log(e, topic);
		let newTopicPrefs: ITaxonomy[];

		switch (e.detail.checked) {
			case true:
				// Item Checked, add it to topic prefs array
				newTopicPrefs = topicPrefs;
				newTopicPrefs.push(topic);

				dispatch({
					type: UPDATE_PREFS_TOPICS,
					payload: {
						topics: newTopicPrefs,
					},
				});
				break;
			default:
				// Item Unchecked, remove it from topic prefs array

				newTopicPrefs = _.filter([...topicPrefs], (currentObject) => {
					return currentObject.slug !== topic.slug;
				});

				dispatch({
					type: UPDATE_PREFS_TOPICS,
					payload: {
						topics: newTopicPrefs,
					},
				});
		}

		return {};
	};

	return (
		<ProfileSection>
			<ProfileSectionTitle>Topics</ProfileSectionTitle>
			<p className="description">Select preferred topics...</p>
			{sortedTopics.map((topic) => {
				return (
					<ChecklistItem key={topic.id}>
						<TopicToggle
							topic={topic}
							clickCallback={clickHandler}
						/>
					</ChecklistItem>
				);
			})}
		</ProfileSection>
	);
};

export default TopicsList;
